// Převod client (obrazovkových) souřadnic na souřadnice ve viewBoxu SVG,
// respektuje výchozí preserveAspectRatio="xMidYMid meet" (letterboxing).
export function clientToSvg(rect, viewBox, clientX, clientY) {
    const scale = Math.min(rect.width / viewBox.w, rect.height / viewBox.h);
    const renderedW = viewBox.w * scale;
    const renderedH = viewBox.h * scale;
    const offsetX = (rect.width - renderedW) / 2;
    const offsetY = (rect.height - renderedH) / 2;
    const x = Math.round((clientX - rect.left - offsetX) / scale);
    const y = Math.round((clientY - rect.top - offsetY) / scale);
    return {x, y};
}
